module.exports = __webpack_public_path__ + "img/message_head.5f2d45a6.png";